/**
 * MODULE: home/homeUtils.js
 * PURPOSE: Small shared formatting helpers used across multiple Home.jsx
 *          sections (avoids duplicating them in every extracted file).
 * PUBLIC API: timeAgo(isoStr), flagEmoji(iso2)
 * CALLED BY: home/Hero.jsx, home/LiveIntelligenceMapSection.jsx,
 *   home/FeaturedCountrySection.jsx, home/TrendingTopicsSection.jsx, pages/Home.jsx
 * LAST REVIEWED: 2026-07-17
 */

export const timeAgo = (isoStr) => {
  if (!isoStr) return "";
  const diff = Math.floor((Date.now() - new Date(isoStr)) / 1000);
  if (diff < 60) return "Just now";
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} h ago`;
  return `${Math.floor(diff / 86400)} d ago`;
};

export const flagEmoji = (iso2) => {
  if (!iso2 || iso2.length !== 2) return "";
  const b = 0x1f1e6 - 65;
  return String.fromCodePoint(b + iso2.toUpperCase().charCodeAt(0)) +
         String.fromCodePoint(b + iso2.toUpperCase().charCodeAt(1));
};
